import { h } from 'preact';
import * as BaseComp from 'components/pages/showtimes/filterStyled.js';
// import s from 'components/pages/showtimes/filterStyled.sss';

export default class FilterStyled extends BaseComp.default {

	alterOptions(options) {
		if (this.props.filter.id !== 'movie') return options;
		let order = ['toni morrison: the pieces i am', 'portrait of a lady on fire', 'misbehaviour'];
		let getIndex = (name) => {
			let lower = (name || '').toLowerCase();
			let cat = order.find(partial => {
				return lower.match(new RegExp('\\b' + partial + '\\b'));
			});
			return cat ? order.indexOf(cat) : order.length;
		};
		options.sort((a, b) => {
			return getIndex(a.display) - getIndex(b.display);
		});
		return options;
	}

}
